<template>
  <div style="height: 100%">
    <div class="backgroundClass" v-if="show == 1">
      <!-- <div class="shadow"></div> -->
      <!-- <div class="header"></div> -->
      <div class="logo">
        <img src="../assets/logo2.png" alt="" />
      </div>
      <div class="title">
        <!-- 兴文县政采云 -->
        <img src="../assets/微信图片_20211227103556.png" alt="" />
      </div>
                  <!-- <h5>数码产品&nbsp;&nbsp;&nbsp;信息技术服务</h5> -->
      <div class="footer">
         <!-- <div :style="{'box-shadow':value}" @click="open('http://dsj.hzxs6688.com/merchant?id=1500682640783601665')">
          <img class="imgUrl" src="../assets/微信图片_20211224150147.png" alt="" />
          <div class="title-info" style="line-height:56px">
            <h5>数网安全服务（含通讯服务）</h5>
          </div>
          <div>经营主体：汇智兴蜀大数据公司</div>
        </div> -->
        <div :style="{'box-shadow':value1}" @click="open('http://xwzqw.com/')">
          <img src="../assets/12.png" alt="" />
          <div class="title-info">
            <h5>办公耗材&nbsp;防疫物资&nbsp;广告印刷</h5>
            <h5>工会福利&nbsp;日用百货&nbsp;后勤服务&nbsp;计算机设备</h5>
          </div>
          <div>经营主体：县农文旅集团</div>
        </div>
        <div :style="{'box-shadow':value2}"  @click="open('http://cjt.hzxs6688.com')">
          <img src="../assets/微信图片_20211224150151.png" alt="" />
          <div class="title-info">
            <h5>劳务用工&nbsp;职工体检&nbsp;环卫绿化</h5>
            <h5>车辆服务&nbsp;物业维修维护&nbsp;法律服务&nbsp;智慧食堂</h5>
          </div>
          <div>经营主体：县发投集团</div>
        </div>
      </div>
      <div
        style="
          text-align: center;
          margin-top: 10vh;
          color: #fff;
          font-size: 18px;
          letter-spacing: 2px;
        "
      >
        <span style="font-size:14px"><a target="_blank"   style="color:#FFFFFF" href="http://beian.miit.gov.cn/">蜀ICP备2022000535-1号</a></span> &nbsp;&nbsp;
        <span style="font-size:14px"><a target="_blank"   style="color:#FFFFFF" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51152802000101">川公网安备 51152802000101号</a></span>
        <h5 style="margin:0.2vh 0">版权所有：四川省汇智兴蜀大数据科技发展有限责任公司</h5>
      </div>
    </div>
    <div class="backgroundClassM" v-if="show == 2">
      <!-- <div class="headerM"></div> -->
      <div class="logoM">
        <img src="../assets/logo2.png" alt="" />
      </div>
      <div class="titleM">
        <img src="../assets/微信图片_20211227103556.png" alt="" />
      </div>
      <div class="typeM">
        <div>
          <img src="../assets/12.png" alt="" />
          <div>
            <h5>日常耗材</h5>
          </div>
          <!-- <div>经营主体：汇智兴蜀大数据公司</div> -->
        </div>
        <div>
          <img src="../assets/微信图片_20211224150147.png" alt="" />
          <div>
            <h5>信息化产品</h5>
          </div>
          <!-- <div>经营主体：县农文旅集团</div> -->
        </div>
        <div>
          <img src="../assets/微信图片_20211224150151.png" alt="" />
          <div>
            <h5>公用事务</h5>
          </div>
          <!-- <div>经营主体：县城交投集团</div> -->
        </div>
      </div>
      <div
        class="footerM"
        style="
          text-align: center;
          margin-top: 50px;
          color: #fff;
          font-size: 12px;
          letter-spacing: 1px;
        "
      >
        <h5>技术支持：四川省汇智兴蜀大数据科技发展有限责任公司</h5>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: 1,
      value:'',
      value1:'',
      value2:''
    };
  },
  methods: {
    open(url) {
      window.location.href = url;
    },
    // enter(num){
    //   // var that = this
    //   // if(num == 1){
    //   //   that.value = '0 0 5px 5px #a8a8a8'
    //   // }else if(num == 2){
    //   //   that.value1 = '0 0 5px 5px #a8a8a8'
    //   // }else{
    //   //   that.value2 = '0 0 5px 5px #a8a8a8' 
    //   // }
    //   // console.log(this.value)
    // },
    // leave(num){
    //   // var that = this
    //   // if(num == 1){
    //   //   that.value = ''
    //   // }else if(num == 2){
    //   //   that.value1 = ''
    //   // }else{
    //   //   that.value2 = '' 
    //   // }
    // }
  },
  mounted() {
    this.flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    console.log(this.flag);
    if (this.flag === null) {
      console.log("pc端");
      this.rightNavShow = true;
      this.show = 1;
    } else {
      console.log("移动端");
      this.show = 2;
      this.rightNavShow = false;
    }
  },
};
</script>
<style>
body,
html {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
  width: 100%;
}
</style>
<style scoped>
.openUrl :hover {
  cursor: pointer;
}
/* 移动 */
.footerM {
  position: absolute;
  bottom: 20px;
  width: 100%;
}
.typeM {
  width: 95%;
  height: auto;
  margin: 6vh auto 12vh auto;
  /* background: chartreuse; */
  display: flex;
}
.typeM > div {
  text-align: center;
  color: #fff;
  font-size: 8px;
  width: 16vh;
  margin: 0 auto;
  /* height: 12vh; */
}
.typeM > div > img {
  width: 12vh;
  height: 11vh;
}
.typeM > div > div {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  width: 80%;
  margin: 0 auto;
}
.headerM {
  width: 100%;
  height: 4vh;
  background-image: url("../assets/QQ截图20211225155803.png");
  background-size: 100% 100%;
}
.logoM {
  height: 17vh;
  width: 100%;
  padding: 5vh 0 10px 0;
  text-align: center;
}
.logoM img {
  width: 17vh;
  height: 100%;
}
.titleM {
  margin: 2vh auto;
  height: 6vh;
  width: 30vh;
}
.titleM img {
  width: 100%;
  height: 100%;
}
/* PC */
.shadow {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1;
  position: absolute;
}
/* img{
    height: 100%;
    width: 100%;
} */
.header {
  width: 100%;
  height: 30px;
  background-image: url("../assets/微信图片_20211224150154.png");
  background-size: 100% 100%;
}
.title {
  width: 150vh;
  height: 14vh;
  /* padding: 2vh; */
  margin: 0 auto;
  text-align: center;
  z-index: 2;
  position: relative;
  letter-spacing: 8vh;
  line-height: 16vh;
  color: #fff;
  font-size: 11vh;
}
.title > img {
  width: 100%;
  height: 100%;
}
.logo {
  height: 25vh;
  width: 25vh;
  padding: 3vh 0 0vh 0vw;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.logo img {
  width: 100%;
  height: 100%;
}
.backgroundClass {
  /* position: relative; */
  min-width: 1300px;
  height: 100%;
  width: 100%;
  background-image: url("../assets/微信图片_20211229145251.png");
  background-size: 100% 100%;
}
.backgroundClassM {
  position: relative;
  height: 100%;
  width: 100%;
  background-image: url("../assets/微信图片_20211227103540.png");
  background-size: 100% 100%;
}
.footer {
  width: 800px;
  display: flex;
  margin: 13vh auto 0 auto;
}
.footer > div {
  /* width: 280px; */
  background: rgba(0, 0, 0, 0);
  height: auto;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  /* background: rgba(0, 0, 0, 0.2); */
}
.footer > div :hover {
  transform:scale(1.2);
}
.title-info {
  width: 320px;
  margin: 0 auto;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.4);
}
.footer img {
  width: 160px;
  height: 130px;
  margin: 0 auto;
}
.footer h5 {
  text-align: center;
  font-size: 16px;
  padding: 2px;
  margin: 10px auto;
}
</style>